export enum TimeGranularity {
    Hour = 0,
    Day = 1,
    Month = 2,
    Year = 3,
    All = 4
}

export interface StatsRangeRequest {
    fromUtc?: string;
    toUtc?: string;
    granularity: TimeGranularity;
}

export interface SummaryRow {
    operation: string; // 'deposit' | 'withdraw'
    paymentMethodId: number;
    paymentMethodTitle: string;
    sum: number; // сумма в копейках
    sumWithCommission: number; // сумма c учетом нашей комиссии в копейках
    percent: number; // процент от общей суммы
    count: number;
}

export interface SummaryResponse {
    rows: SummaryRow[];
    totalDepositSum: number; // сумма в копейках
    totalWithdrawalSum: number; // сумма в копейках
}

export interface GroupedSummaryRow {
    bucketUtc: string; // DateTime в ISO формате
    operation: string; // 'deposit' | 'withdraw'
    paymentMethodId: number;
    paymentMethodTitle: string;
    sum: number; // сумма в копейках
    sumWithCommission: number; // сумма c учетом нашей комиссии в копейках
    percent: number; // процент от общей суммы
    count: number;
}

export interface GroupedSummaryResponse {
    rows: GroupedSummaryRow[];
    totalDepositSum: number; // сумма в копейках
    totalWithdrawalSum: number; // сумма в копейках
}

export interface DataPoint {
    bucketUtc: string; // DateTime в ISO формате
    value: number; // значение в копейках
}

export interface DualDataResponse {
    deposits: DataPoint[];
    withdrawals: DataPoint[];
    totalDeposits: number; // сумма в копейках
    totalWithdrawals: number; // сумма в копейках
}
